import { all, fork } from 'redux-saga/effects';
import { watchGetProfile, watchLogout, watchLogin, watchRegister } from './access.sagas';
import { watchProduct } from './product.sagas';
import watchToggleModal from './modals.sagas';

export default function* rootSaga() {
	yield all([fork(watchGetProfile), fork(watchLogin), fork(watchRegister), fork(watchLogout), fork(watchToggleModal), fork(watchProduct)]);
}
